import { lazy } from "react";
import Loadable from "components/Loadable.tsx";

const CourseSpecializationList = Loadable(
  lazy(() => import("features/courseSpecialization/components/List"))
);
const CourseSpecializationPage = Loadable(
  lazy(() => import("features/courseSpecialization/components/Page"))
);

const routes = {
  path: "courseSpecialization",
  children: [
    { path: "", element: <CourseSpecializationList /> },
    { path: "add", element: <CourseSpecializationPage /> },
    { path: "edit/:courseSpecializationId?", element: <CourseSpecializationPage /> },
  ],
};

export default routes;
